import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import { changeContent, addObservations, switchAppointmentOrBudget } from './actions'
import { removeFromCart } from '../../../components/shoppingCart/actions'
import ObservationsForm from './observationsForm.component'
import { switchCheckoutContent } from '../checkoutContent/actions'
import { renderSearchMainServiceKm } from './../../../catalogue'
import { configuration } from '../../../configuration'

import './styles.css';
class Observations extends React.Component {

  static propTypes = {
    services: PropTypes.shape({
      element: PropTypes.object,
    }),
  }

  constructor(props) {
    super(props);

    this.addObservationsToCartItem = this.addObservationsToCartItem.bind(this);
  }

  handleSubmit() {
    console.log('Submitting...')
  }

  renderSearchMainServiceKm() {
    // Render Buscador de servicios de mantenimiento programado
    const history = this.props.catalogue.history;
    if (history && history[0].name === configuration().mainServiceKmName && history.length === 1) {
      this.props.renderSearchMainServiceKm(true);
    } else {
      this.props.renderSearchMainServiceKm(false);
    }
  }

  back(element) {
    this.renderSearchMainServiceKm()
    let cartIndex = this.props.cart.items.indexOf(element);
    if (cartIndex !== -1) {
      this.props.removeFromCart(cartIndex);
    }
    this.props.changeContent(null);
  }

  addObservationsToCartItem(next) {
    const formValues = this.props.observationsForm.values || {}
    this.props.addObservations(this.props.services.element, formValues.observations || '');
    if (next) {
      if (this.props.cart.forfait) {
        this.props.switchAppointmentOrBudget(false)
        this.props.switchCheckoutContent('appointment');
      } else {
        this.props.switchAppointmentOrBudget(true)
      }
    } else {
      this.renderSearchMainServiceKm()
    }
  }
  componentWillUnmount() {
    this.props.changeContent(null);
  }

  render() {
    return (
      <div className="bubocar-comment-box">
        <p className="meta-text">Añadir comentarios sobre <b>{this.props.services.element.name}</b> (opcional):</p>
        <ObservationsForm />
        <Row>
          <Col sm={12} md={5} className="offset-md-7">
            <button className=" responsivebutton jump button-secondary set-hover-button pull-right blue-button"
              style={{
                borderColor: configuration().clientColor,
                color: configuration().clientColor,
              }}
              onClick={() => this.addObservationsToCartItem(false)}>
              <span className="labelFlip1">AÑADIR OTRO SERVICIO</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>AÑADIR OTRO SERVICIO</span>
            </button>
          </Col>
        </Row>
        <Row>
          <Col md={3} sm={6}>
            <button className=" responsivebutton jump pull-left button-secondary router-buttons" disabled={!this.props.catalogue.history.length} onClick={() => this.back(this.props.services.element)}>{configuration().arrowInButon ? <i className="fa fa-angle-left" aria-hidden="true"></i> : ''}
              <span className="labelFlip1">ATRÁS</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>ATRÁS</span>
            </button>
          </Col>
          <Col md={4} sm={6} className="offset-md-5">
            <button
              className="responsivebutton jump button-primary pull-right blue-button-active"
              style={{
                backgroundColor: configuration().clientColor,
                borderColor: configuration().clientColor,
              }}
              onClick={() => this.addObservationsToCartItem(true)}>
              <span className="labelFlip1">SIGUIENTE</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>SIGUIENTE</span>
            </button>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  catalogue: state.catalogue,
  observationsForm: state.form.observationsForm || {},
  cart: state.checkout.shoppingCart,
  services: state.checkout.servicesData,
  renderAppointmentOrBudget: state.checkout.servicesData.renderAppointmentOrBudget,
})

const bindActions = dispatch => ({
  removeFromCart: index => dispatch(removeFromCart(index)),
  changeContent: element => dispatch(changeContent(element)),
  addObservations: (item, observations) => dispatch(addObservations(item, observations)),
  switchCheckoutContent: content => dispatch(switchCheckoutContent(content)),
  renderSearchMainServiceKm: (mainServiceKm) => dispatch(renderSearchMainServiceKm(mainServiceKm)),
  switchAppointmentOrBudget: (renderAppointmentOrBudget) => dispatch(switchAppointmentOrBudget(renderAppointmentOrBudget)),
})

export default connect(mapStateToProps, bindActions)(Observations)



// WEBPACK FOOTER //
// ./src/workflow/checkout/services/observations.component.js